import { render, staticRenderFns } from "./desk-main.vue?vue&type=template&id=4d1c5d8c&scoped=true&"
import script from "./desk-main.vue?vue&type=script&lang=js&"
export * from "./desk-main.vue?vue&type=script&lang=js&"
import style0 from "./desk-main.vue?vue&type=style&index=0&id=4d1c5d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c5d8c",
  null
  
)

export default component.exports